import React from 'react';

const svg = (children, size = 18, extra = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...extra}
  >
    {children}
  </svg>
);

export const QueueIcon = ({ size }) =>
  svg(<><rect x="3" y="4" width="18" height="16" rx="3" /><path d="M7 9h10M7 13h10M7 17h6" /></>, size);
export const BillsIcon = ({ size }) =>
  svg(<><path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" /><path d="M9 8h6M9 12h6M9 16h3" /></>, size);
export const ChartIcon = ({ size }) => svg(<><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></>, size);
export const PlusIcon = ({ size }) => svg(<><path d="M12 5v14M5 12h14" /></>, size);
export const RefreshIcon = ({ size }) =>
  svg(<><path d="M21 12a9 9 0 1 1-3-6.7L21 8" /><path d="M21 3v5h-5" /></>, size);
export const SearchIcon = ({ size }) => svg(<><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></>, size);
export const TrashIcon = ({ size }) =>
  svg(<><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13M10 11v6M14 11v6" /></>, size);
export const BackIcon = ({ size }) => svg(<path d="M15 18l-6-6 6-6" />, size);
export const CheckIcon = ({ size }) => svg(<path d="M5 12l5 5 9-10" />, size);
export const ChevronIcon = ({ size, open }) => svg(<path d={open ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6'} />, size);
export const BranchIcon = ({ size }) =>
  svg(<><path d="M3 21h18M5 21V8l7-5 7 5v13" /><path d="M9 21v-6h6v6" /></>, size);
export const PhoneIcon = ({ size }) =>
  svg(
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2" />,
    size,
  );
export const IdIcon = ({ size }) =>
  svg(<><rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="9" cy="12" r="2.5" /><path d="M14 10h4M14 14h3" /></>, size);
export const FaceIcon = ({ size }) =>
  svg(<><path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3" /><circle cx="12" cy="11" r="3" /><path d="M8 17c1-1.5 2.4-2 4-2s3 .5 4 2" /></>, size);
export const UserIcon = ({ size }) => svg(<><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-6 8-6s8 2 8 6" /></>, size);
export const PrintIcon = ({ size }) =>
  svg(<><path d="M7 9V3h10v6" /><rect x="3" y="9" width="18" height="8" rx="2" /><path d="M7 14h10v7H7z" /></>, size);
export const WhatsAppIcon = ({ size }) =>
  svg(<><path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.6-1.2A9 9 0 1 0 12 3z" /><path d="M9 9.5c0 3 2.5 5.5 5.5 5.5" /></>, size);
export const CashIcon = ({ size }) =>
  svg(<><rect x="2" y="6" width="20" height="12" rx="2" /><circle cx="12" cy="12" r="2.5" /><path d="M6 12h.01M18 12h.01" /></>, size);
export const UpiIcon = ({ size }) =>
  svg(<><rect x="6" y="2" width="12" height="20" rx="2.5" /><path d="M10 18h4M9.5 8.5l2 6 2.5-6" /></>, size);
export const EyeIcon = ({ size }) =>
  svg(<><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>, size);
export const MenuIcon = ({ size }) => svg(<path d="M3 6h18M3 12h18M3 18h18" />, size || 20);
export const CloseIcon = ({ size }) => svg(<path d="M6 6l12 12M18 6L6 18" />, size);
